<template>
  <div class="data-list">
    <van-pull-refresh v-model="refreshLoading" @refresh="reload()">
      <van-list
        v-if="show"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <div class="list-item" v-for="(item, index) in list" :key="index">
          <slot name="item" :item="item" :index="index" v-if="type"></slot>
          <slot name="item" v-bind="item" v-else></slot>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { List, PullRefresh } from "vant";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "DataList",
  components: {
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
  },
  props: {
    type: {
      type: Number,
      default: 0,
    },
    api: {
      type: Function,
      default: () => {},
    },
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    onAutoLoad: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default() {
        return {};
      },
    },
    dataType: {
      type: String,
      default: "",
    },
    onLoadCallBack: { type: Function },
  },

  data() {
    return {
      list: [],
      show: true,
      refreshLoading: false,
      loading: false,
      finished: false,
      error: false,
      tabActive: 0,
      PageIndex: 0,
    };
  },
  watch: {
    params() {
      this.reload();
    },
    data() {
      this.onLoad();
    },
    api() {
      this.reload();
    },
  },
  created() {
    if (this.onAutoLoad) {
      this.loading = false;
      this.finished = true;
    }
    if (this.data && this.data.length) {
      this.onLoad();
    }
  },
  methods: {
    onLoad() {
      const base = {
        PageIndex: this.PageIndex,
        PageSize: 10,
      };
      let json = { ...base, ...this.params };
      let params = null;
      if (this.dataType == "formdata") {
        var formData = new FormData();
        for (var key in this.params) {
          if (key == "pageIndex") {
            formData.append(key, json["PageIndex"]);
          } else if (key == "pageSize") {
            formData.append(key, json["PageSize"]);
          } else {
            formData.append(key, json[key]);
          }
        }
        params = formData;
      } else {
        params = json;
      }

      if (this.api) {
        this.api(params)
          .then(res => {
            let data = res.Data.Datas;
            if (this.onLoadCallBack) {
              const callbackRes = this.onLoadCallBack(res);
              if (callbackRes) {
                data = callbackRes;
              }
            }
            this.PageIndex = json.PageIndex + 1;

            this.list = this.list.concat(data);
            this.loading = false;
            if (
              this.list.length >= res.Data.Total ||
              this.list.length >= res.Data.length
            ) {
              this.finished = true;
            }
            this.refreshLoading = false;
          })
          .catch(() => {
            this.loading = false;
            // this.error = true;
            this.finished = true;
          });
      } else if (this.data && this.data.length) {
        this.list = this.data;
        this.loading = false;
        this.finished = true;
      }
      // else {
      //   //暂时模拟数据
      //   let data = [];
      //   for (let i = 0; i < 30; i++) {
      //     data.push({
      //       id: i,
      //       date: "2019-01-01",
      //       money: 100
      //     });
      //   }
      //   this.list = data;
      //   this.loading = false;
      //   this.finished = true;
      // }
    },
    reload() {
      this.list = [];
      this.PageIndex = 0;
      this.finished = false;
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    changeRow(index, callback) {
      this.list[index] = callback(this.list[index]);
    },
    changeAll(option) {
      let list = cloneDeep(this.list);
      for (var i in option) {
        list.map(p => (p[i] = option[i]));
      }
      this.list = list;
    },
  },
};
</script>

<style lang="less" scoped>
.data-list {
  font-size: 0.35rem;
}
</style>
